import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.balma-osteopathe.fr";
const SITE_NAME = "Maxime Nicolaieff Ostéopathe D.O.";
const DEFAULT_IMG = `${SITE_URL}/og-image.webp`;
const DEFAULT_DESC = "Maxime Nicolaieff, ostéopathe D.O. à Balma et Castelnau-d'Estrétefonds. Douleurs du dos, cervicales, migraines, sciatique, nourrissons, femmes enceintes. Prise en charge globale.";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/icone.png`,
  telephone: "+33695788983",
  email: "nicolaieffmaxime@gmail.com",
  sameAs: ["https://www.doctolib.fr/osteopathe/balma/maxime-nicolaieff"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "8 Route de Mons",
    addressLocality: "Balma",
    postalCode: "31130",
    addressCountry: "FR",
  },
};

const SEO = ({ title, description, path = "", image = DEFAULT_IMG, noIndex = false, schema }) => {
  const desc = description || DEFAULT_DESC;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  const pageSchemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  const allSchemas = [ORGANIZATION_SCHEMA, ...pageSchemas];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">{JSON.stringify(allSchemas)}</script>
    </Helmet>
  );
};

export default SEO;
